export default __webpack_public_path__ + "static/media/registration-profile.60fbc1b2.png";